<template>
  <ap-modal
    v-model:open="visible"
    :title="$t(`You've reached the limit for active QR codes`)"
    class="p-0 limit-reached-modals-qr"
    centered
    @cancel="handleCancel"
    :closable="false">
    <p
      class="text-black/60 text-sm mb-0"
      v-html="
        $t('components.modal.upgrade.limit.body', {
          plan_name: userPlan?.name,
          limit: userPlan?.features?.limits?.qr
        })
      " />

    <template #footer>
      <div class="flex justify-end w-full mt-4">
        <ap-button
          type="default"
          class="bg-white border-black/30 text-primary rounded h-8"
          @click="handleCancel">
          {{ $t("components.modal.upgrade.limit.cancel.btn") }}
        </ap-button>
        <UpgradePlanButton
          :label="$t('components.modal.upgrade.limit.confirm.btn')"
          class="!rounded !h-8"
          @click="handleCancel"
          @close-modal="handleCancel" />
      </div>
    </template>
  </ap-modal>
</template>

<script setup>
import { storeToRefs } from "pinia"
import UpgradePlanButton from "@/components/UpgradePlan/UpgradePlanButton.vue"
import { useUserAccountsStore } from "../../stores/userAccounts"

const emit = defineEmits(["close"])
const visible = defineModel("open", {
  default: false,
  type: Boolean
})
const { userPlan } = storeToRefs(useUserAccountsStore())
function handleCancel() {
  emit("close")
}
</script>

<style lang="postcss">
.limit-reached-modals-qr {
  .ant-modal-content {
    @apply !rounded-lg px-4 pt-8 pb-4 w-[29rem];

    .ant-modal-header .ant-modal-title {
      @apply text-[20px] font-semibold text-black;
    }

    .ant-modal-body {
      @apply mb-8;
    }
  }
}
</style>
